module.exports = __webpack_public_path__ + "static/media/test14_4.d15884a6.png";